import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import home from '@/pages/home.vue'
Vue.use(Router)
const routes = [
  {
    path: '',
    redirect:'/home'
  },
  {
    path: '/home',
    name:'home',
    component:() =>
    import('@/pages/home.vue'),
  },
  {
    path: '/privacypolicy',
    name:'privacypolicy',
    component: () =>
      import('@/pages/detailPage/privacypolicy'),
  },
  {
    path:'/callMe',
    name:'callMe',
    component: () =>
      import('@/pages/detailPage/callMe'),
  },
  {
    path:'/commonMessage',
    name:'commonMessage',
    component: () =>
      import('@/pages/detailPage/commonMessage'),
  },
  {
    path:'/newsDetails',
    name:'newsDetails',
    component: () =>
      import('@/pages/detailPage/newsDetails'),
  },
  {
    path:'/voucherCenter',
    name:'voucherCenter',
    component: () =>
      import('@/pages/detailPage/voucherCenter'),
  }
]
const router=new Router({
  routes:routes, 
  mode: 'hash'}
)
router.beforeEach(async (to, from, next) => {
  // 检查是否已经加载过公司信息
  store.commit('SET_LOADING', true)
  try {
    await store.dispatch('getCompanyInfo')
    next()
  } catch (error) {
    console.error('加载公司信息失败:', error)
    next()
  } finally {
    store.commit('SET_LOADING', false)
  }
})
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   if (to.path === '/login') {
//     sessionStorage.removeItem('izOutCamera')
//   }
//   let user = sessionStorage.getItem('izOutCamera')
//   if (!user && to.path !== '/login') {
//     // 若本地token不存在,则任意路由跳转的时候,重定向至login 登陆页面
//     next({
//       path: '/login',
//       // query: { redirect:to.fullPath}  // 将刚刚要去的路由path（却无权限）作为参数，方便登录成功后直接跳转到该路由
//     })
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js